<template>
  <div class="visual-element-image">
    <FormVisualElement @valid="$emit('valid', $event)">
      <FormRow
        class="w-1/2 mb-10"
        label="Formato"
        :forId="`visual-element-format-${_id}`"
        name="format"
        rules="required"
        legend="(per cambiare valore rimuovi prima tutte le immagini)"
      >
        <v-select
          v-model="modelDataElement.format"
          :options="formatOptions"
          :searchable="false"
          :clearable="false"
          :reduce="type => type.value"
          :disabled="modelDataElement.images.length > 0"
        />
      </FormRow>

      <div
        v-for="(image, i) in modelDataElement.images"
        :key="i"
        class="border-t border-solit border-gray-300 bg-gray-100"
      >
        <RepeaterCollapse :wide="true">
          <template v-slot:header>
            <div class="py-4 pl-4">
              <span class="text-sans-md font-bold text-gray-800"
                >Immagine #{{ i + 1 }}</span
              >
            </div>
          </template>

          <template v-slot:default>
            <div class="px-4 pb-4" :key="image.src">
              <FormRow
                label="Seleziona un'immagine"
                legend="(dimensioni suggerite - fullscreen: 750x1334px - quadrata: 750x750px)"
                :for-id="`visual-element-image-${_id}-${i}`"
                name="Immagine"
                rules="required"
                :legend-block="true"
              >
                <v-image-input
                  :id="`visual-element-image-${_id}-${i}`"
                  :podcastId="podcastId"
                  :imageWidth="750"
                  :imageHeight="
                    modelDataElement.format === 'square' ? 750 : 1334
                  "
                  name="image"
                  v-model="modelDataElement.images[i].src"
                  label="Carica foto"
                  @img_size="updateSizes(i, $event)"
                />
              </FormRow>

              <FormRow
                label="Didascalia"
                legend="(facoltativa)"
                :for-id="`visual-element-image-text-${_id}-${i}`"
                name="text"
              >
                <v-medium-editor
                  :id="`visual-element-image-text-${_id}-${i}`"
                  name="text"
                  v-model="modelDataElement.images[i].text"
                />
              </FormRow>
            </div>
          </template>

          <template v-slot:actions>
            <div class="pr-4">
              <button class="btn-round-icon-alt" @click="removeImage(i)">
                <IconTrash />
              </button>
            </div>
          </template>
        </RepeaterCollapse>
      </div>

      <div class="py-8">
        <button class="btn-round-icon-outline" @click="addImage">
          <IconPlus />
        </button>
        <span class="text-sans-base font-bold ml-2 text-gray-800"
          >Aggiungi una immagine</span
        >
      </div>
    </FormVisualElement>
  </div>
</template>

<script>
/** Icons */
import IconPlus from '@/assets/icons/icon-plus.svg'
import IconTrash from '@/assets/icons/icon-trash.svg'

/** Components */
import VisualElementBase from '@/components/VisualElementBase.vue'
import RepeaterCollapse from '@/components/RepeaterCollapse.vue'

export default {
  extends: VisualElementBase,

  components: {
    IconPlus,
    IconTrash,
    RepeaterCollapse,
  },

  defaultContent: {
    format: 'fullscreen',
    images: [],
  },

  data() {
    return {
      updateLoading: false,
      formatOptions: [
        { label: 'Fullscreen', value: 'fullscreen' },
        { label: 'Quadrato', value: 'square' },
      ],
    }
  },
  methods: {
    updateSizes(i, [width, height]) {
      this.modelDataElement.images[i].width = width
      this.modelDataElement.images[i].height = height
    },
    addImage() {
      this.modelDataElement.images = [
        ...this.modelDataElement.images,
        {
          src: '',
          width: 0,
          height: 0,
          text: '',
        },
      ]
    },
    removeImage(index) {
      this.modelDataElement.images = this.modelDataElement.images.filter(
        (_, i) => i !== index,
      )
    },
  },
}
</script>
